import type { OrdersBoardColumn } from './OrdersBoard.types'

// Helper function for column configuration
export function createColumnConfig(
  id: string,
  options?: Partial<Omit<OrdersBoardColumn, 'id'>>,
): OrdersBoardColumn {
  return {
    id,
    ...options,
  }
}
